export const INCREMENT = 'INCREMENT'
export const ADD = 'ADD'

export const SEND_REQUEST = 'SEND_REQUEST'
export const REQUEST_SUCCEED = 'REQUEST_SUCCEED'
export const REQUEST_FAILED = 'REQUEST_FAILED'

export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL'
export const CLOSE_LOGIN_MODAL = 'CLOSE_LOGIN_MODAL'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

export const ADD_MESSAGE = 'ADD_MESSAGE'

// 搜索地图选择地址
export const MAP_SAVE_POINT = 'MAP_SAVE_POINT'
export const MAP_SAVE_ADDRESS = 'MAP_SAVE_ADDRESS'
export const MAP_SAVE_AREA_ID = 'MAP_SAVE_AREA_ID'
export const MAP_SAVE_INFO = 'MAP_SAVE_INFO'
export const MAP_CLEAR_MAP_ADDRESS = 'MAP_CLEAR_MAP_ADDRESS'
export const MAP_SAVE_PROVINCES = 'MAP_SAVE_PROVINCES'
export const MAP_SAVE_DETAIL_ADDRESS = 'MAP_SAVE_DETAIL_ADDRESS'

// 斐艺购模块的 mutation 类名以 MALL 开头，如下：
export const MALL_CART_ITEM_ID_ARR = 'MALL_CART_ITEM_ID_ARR'
export const MALL_RECEIVE_CART_GOODS_COUNT = 'MALL_RECEIVE_CART_GOODS_COUNT'
export const MALL_SAVE_CATEGORY = 'MALL_SAVE_CATEGORY'
export const MALL_CLEAR_CATEGORY = 'MALL_CLEAR_CATEGORY'

// 登录后的会员中心
export const MEMBER_STORE_MANAGE_STORE_INFO = 'MEMBER_STORE_MANAGE_STORE_INFO'

// 会员中心登录
export const MEMBER_IS_LOGIN = 'MEMBER_IS_LOGIN'
export const MEMBER_SHOW_LOGIN = 'MEMBER_SHOW_LOGIN'
export const MEMBER_INFORMATION = 'MEMBER_INFORMATION'
export const MEMBER_CLEAR_INFO = 'MEMBER_CLEAR_INFO'
export const PAGE_HAS_POSITION = 'PAGE_HAS_POSITION'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js